<template lang="pug">
  div
    .text-sm.font-semibold.mb-2 Redeeming member
    search-member-dropdown.mt-2.mb-3(v-if="memberSelectable" v-model="selectedMember" @change="handleChangeSelection")
    v-text-field.round-xl.mb-4(v-else-if="member" :value="member.name" dense height="48" outlined readonly hide-details)
    template(v-if="member")
      stamp-current-progress(v-if="loyaltySystem === 'stamps'" :stampCollected="collectedValue" :rewardsPosition="rewardsPosition")
      point-current-progress.mb-4(v-else :pointCollected="collectedValue" :availableRewards="availableRewards" showCurrentProgressText)
      .text-sm.font-semibold.mb-2 Choose which reward you would like to redeem
      template(v-if="rewards.isFetching")
        v-skeleton-loader(type="list-item-two-line@3")
      template(v-else-if="rewards.isError")
        .text-xs.danger500--text Opss! Something went wrong
      template(v-else)
        v-radio-group(v-model="selectedReward")
          v-row(no-gutters)
            v-col.mb-4(cols="12" v-for="reward in rewards.data" :key="reward.id")
              template(v-if="reward.disabled")
                v-card.round-lg.pa-4(outlined disabled)
                  reward-to-redeem-item(:reward="reward" :loyaltySystem="loyaltySystem" disabled)
              template(v-else)
                v-card.round-lg.pa-4(outlined :class="[{ 'border-selected': isSelected(reward) }]" @click="handleSelectReward(reward)")
                  reward-to-redeem-item(:reward="reward" :loyaltySystem="loyaltySystem")
</template>

<script>
import StampCollections from "@/components/clinic/checkout/marketing/collecting/stamps/StampCollections.vue";
import StampCurrentProgress from "@/components/clinic/checkout/marketing/collecting/stamps/StampCurrentProgress.vue";
import {mapActions, mapGetters} from "vuex";
import RewardToRedeemItem from "@/components/clinic/checkout/marketing/redeem/reward/RewardToRedeemItem.vue";
import PointCurrentProgress from "@/components/clinic/checkout/marketing/collecting/points/PointCurrentProgress.vue";
import SearchMemberDropdown from "@/components/clinic/marketing/SearchMemberDropdown.vue";

export default {
  components: {
    SearchMemberDropdown,
    PointCurrentProgress,
    RewardToRedeemItem,
    StampCurrentProgress,
    StampCollections,
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    member: {
      type: Object,
      default: null
    },
    collectedValue: {
      type: Number,
      default: 0
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
    availableRewards: {
      type: Array,
      default: () => ([])
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    memberSelectable: {
      type: Boolean,
    }
  },
  data() {
    return {
      selectedReward: null,
      rewards: {
        isFetching: true,
        isError: false,
        data: [],
      },
      selectedMember: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedMember = this.member
    })
    this.fetchRewards()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchRewards() {
      try {
        this.rewards.isFetching = true
        const url = `/loyalty/${this.company.slug}`
        const params = {
          fields: 'rewards',
        }
        const { data } = await this.$axios.get(url, { params })
        this.rewards.data = data.rewards.map((reward, index) => this.sanitizeData(reward, index))
      } catch (error) {
        this.rewards.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.rewards.isFetching = false
      }
    },
    handleSelectReward(reward) {
      this.selectedReward = reward
      this.$emit('input', this.selectedReward)
    },
    isSelected(reward) {
      return this.selectedReward?.id === reward.id
    },
    sanitizeData(reward, index) {
      const newObj = {
        ...reward
      }
      const disabled = !this.availableRewards.includes(reward.id)
      newObj.disabled = disabled
      newObj.eligibility = this.getEligibilityText(disabled, reward, index)
      return newObj
    },
    getEligibilityText(disabled, reward, index) {
      if (this.loyaltySystem === 'points') return `-${reward.tier_value} pts`

      if (!disabled) return 'Eligible'
      const eligibilityCount = this.getEligibilityCount(index)
      if (eligibilityCount <= 0) return 'Redeemed'
      return `${eligibilityCount} more needed`
    },
    getEligibilityCount(index) {
      return this.rewardsPosition[index] - this.collectedValue
    },
    handleChangeSelection() {
      this.handleSelectReward(null)
      this.$emit('update:member', this.selectedMember)
      this.$nextTick(() => {
        this.rewards.data = this.rewards.data.map((reward, index) => this.sanitizeData(reward, index))
      })
    }
  },
}
</script>

<style scoped>
.border-selected {
  border: 2px solid #333333 !important;
}

.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>